import React from "react";
import { X, Search, Grid3x3, List } from "lucide-react";

const ViewControls = ({
  viewMode,
  onViewModeChange,
  onClearFilters,
  onSearchClick,
  hasActiveFilters,
  isMobile
}) => {
  return (
    <div className="filter-controls-desktop">
      {window.innerWidth > 768 && (
        <div className="view-toggle-desktop">
          <button
            className={`clear-filters-icon-btn ${
              hasActiveFilters ? "active" : !hasActiveFilters ? "disabled" : ""
            }`}
            onClick={onClearFilters}
            aria-label="Clear all filters"
            disabled={!hasActiveFilters}
          >
            <X
              size={24}
              color={!hasActiveFilters ? "#666" : "#000"}
            />
          </button>
          <button
            className={`view-btn ${viewMode === "card" ? "active" : ""}`}
            onClick={() => onViewModeChange("card")}
            aria-label="Card view"
          >
            <Grid3x3
              size={24}
              color={viewMode === "card" ? "#e6c618" : "#666"}
            />
          </button>
          <button
            className={`view-btn ${viewMode === "row" ? "active" : ""}`}
            onClick={() => onViewModeChange("row")}
            aria-label="Row view"
          >
            <List
              size={24}
              color={viewMode === "row" ? "#e6c618" : "#666"}
            />
          </button>
        </div>
      )}
      {window.innerWidth > 768 && (
        <button
          className="search-icon-btn"
          onClick={onSearchClick}
          aria-label="Search items"
        >
          <Search size={24} />
        </button>
      )}
    </div>
  );
};

export default ViewControls;
